// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__oK5QN","container":"style_container__+VTGN","spanContent":"style_spanContent__VWqcD","actions":"style_actions__Yu2TI"};